import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 获取下载地址
export const getGameLink = () => http.httpGet({
  url: httpApi.homes.getGameLink,
})

// 获取QQ一键加群KEY
export const getQQKey = () => http.httpGet({
  url: httpApi.homes.getQQKey
})

// 获取盒子下载链接
interface GetDownUrlData {
  channel_type: number,
  device: string,
  channel_code: string,
}

export const getDownUrl = (json: GetDownUrlData): any => http.httpPost({
  url: httpApi.homes.getDownUrl,
  json,
})

// 排行榜
interface HomeListData {
  token: string,
}

export const homeList = (json: HomeListData): any => http.httpPost({
  url: httpApi.homes.homeList,
  json,
})

// 新闻列表
interface GetNewsListData {
  size: number,
  page: number,
  is_seo: number
}

export const getNewsList = (json: GetNewsListData): any => http.httpPost({
  url: httpApi.homes.getNewsList,
  json
})

// 获取新闻详情
interface GetNewsInfoData {
  id: string,
}

export const getNewsInfo = (json: GetNewsInfoData): any => http.httpPost({
  url: httpApi.homes.getNewsInfo,
  json
})

// 游戏详情
interface GameInfoJson {
  box_game_id: string,
}

export const gameInfo = (json: GameInfoJson): any => http.httpPost({
  url: httpApi.homes.gameInfo,
  json,
})

// 同厂推荐
interface FirmRecommendJson {
  box_game_id: string,
  factory_id: string
}
export const firmRecommend = (json: FirmRecommendJson): any => http.httpPost({
  url: httpApi.homes.firmRecommend,
  json,
})

// 新游推荐
export const newGameList = (): any => http.httpGet({
  url: httpApi.homes.newGameList
})

interface ByRandData {
  token: string
}
// 版本与标签接口
export const tagList = (json: ByRandData): any => http.httpPost({
  url: httpApi.homes.tagList,
  json
})

// 版本与标签接口
export const getAllVersionAndTagList = (json: ByRandData): any => http.httpPost({
  url: httpApi.homes.getAllVersionAndTagList,
  json
})

// 时间段配置获取
export const getTimeSection = (json: ByRandData): any => http.httpPost({
  url: httpApi.homes.getTimeSection,
  json
})

// 开服列表
interface GetListShunWanData {
  bow_time: number;
  page: number;
  size: number;
  section_id: string;
  versionid: string;
  tag: string;
}
// 版本与标签接口
export const getListShunWan = (json: GetListShunWanData): any => http.httpPost({
  url: httpApi.homes.getListShunWan,
  json
})

